import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import App from './App';
import './styles/global.css';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
